import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["label", "inline", "error", "readOnly", "disabled", "required", "value", "dateFormat", "wrapperClass", "inputContainerClassName"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import { TimePicker as AntdTimePicker } from 'antd';
import { EMPTY_STRING } from '@tekion/tekion-base/app.constants';
import Label from '../Label';
import styles from './timePicker.module.scss';
import './timepicker.antd.scss';
var TimePicker = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(TimePicker, _React$PureComponent);
  var _super = _createSuper(TimePicker);
  function TimePicker() {
    _classCallCheck(this, TimePicker);
    return _super.apply(this, arguments);
  }
  _createClass(TimePicker, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        label = _this$props.label,
        inline = _this$props.inline,
        error = _this$props.error,
        readOnly = _this$props.readOnly,
        disabled = _this$props.disabled,
        required = _this$props.required,
        value = _this$props.value,
        dateFormat = _this$props.dateFormat,
        _wrapperClass = _this$props.wrapperClass,
        inputContainerClassName = _this$props.inputContainerClassName,
        rest = _objectWithoutProperties(_this$props, _excluded);
      var wrapperClass = _wrapperClass;
      if (readOnly) {
        wrapperClass = cx(wrapperClass, styles.readOnly);
      }
      if (disabled) {
        wrapperClass = cx(wrapperClass, styles.disabled);
      }
      var errorStyles = error && styles.inputError;
      return /*#__PURE__*/React.createElement("div", {
        className: cx(wrapperClass)
      }, label && /*#__PURE__*/React.createElement(Label, {
        className: styles.label,
        required: required
      }, label), /*#__PURE__*/React.createElement("div", {
        className: cx(styles.input, errorStyles, inputContainerClassName)
      }, /*#__PURE__*/React.createElement(AntdTimePicker, _extends({
        value: value,
        format: dateFormat
      }, rest, {
        disabled: disabled
      }))), error && /*#__PURE__*/React.createElement("span", {
        className: styles.error
      }, error));
    }
  }]);
  return TimePicker;
}(React.PureComponent);
_defineProperty(TimePicker, "defaultProps", {
  wrapperClass: EMPTY_STRING,
  inputContainerClassName: EMPTY_STRING
});
_defineProperty(TimePicker, "propTypes", {
  wrapperClass: PropTypes.string,
  inputContainerClassName: PropTypes.string
});
export default TimePicker;